// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1-Hew","header":"PatientBlock_header__36DlU","label":"PatientBlock_label__2SGAQ","option":"PatientBlock_option__3vzl8"};